import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import translations from './translations';
import * as dayjs from 'dayjs';
import css from './style.pcss';
var RTLFuelPrices = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLFuelPrices, _LitElement);
  function RTLFuelPrices() {
    var _this;
    _classCallCheck(this, RTLFuelPrices);
    _this = _callSuper(this, RTLFuelPrices);
    _this.language = 'lu';
    _this.type = 'all';
    _this.apiUrl = "https://api-gate.rtl.lu";
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }

  // createRenderRoot(){ return this; }
  _createClass(RTLFuelPrices, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLFuelPrices.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_fetchData",
    value: function () {
      var _fetchData2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var last, graphData, graph;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return fetch(this.apiUrl + "/fuel-prices/current").then(function (resp) {
                return resp.json();
              });
            case 2:
              last = _context.sent;
              _context.next = 5;
              return fetch(this.apiUrl + "/fuel-prices/average").then(function (resp) {
                return resp.json();
              });
            case 5:
              graphData = _context.sent;
              graph = convertGraphData(graphData);
              this.data = {
                last: last,
                graph: graph
              };
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _fetchData() {
        return _fetchData2.apply(this, arguments);
      }
      return _fetchData;
    }()
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_renderGraph",
    value: function () {
      var _renderGraph2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(data) {
        var _this2 = this;
        var _yield$import, Chart, LineController, Legend, LineElement, CategoryScale, LinearScale, PointElement, labels, datasets, elm, chart;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return import( /* webpackChunkName: "chartjs" */'chart.js');
            case 2:
              _yield$import = _context2.sent;
              Chart = _yield$import.Chart;
              LineController = _yield$import.LineController;
              Legend = _yield$import.Legend;
              LineElement = _yield$import.LineElement;
              CategoryScale = _yield$import.CategoryScale;
              LinearScale = _yield$import.LinearScale;
              PointElement = _yield$import.PointElement;
              labels = [];
              data.labels.forEach(function (label) {
                labels.push(_this2._getTranslation('months')[label]);
              });

              //console.log(labels);
              datasets = [{
                label: this._getTranslation('98oct'),
                data: data.oct98,
                fill: false,
                backgroundColor: "rgba(74,144,226, 0.4)",
                borderColor: "rgb(74,144,226)",
                lineTension: 0.1
              }, {
                label: this._getTranslation('95oct'),
                data: data.oct95,
                fill: false,
                backgroundColor: "rgba(189,10,26, 0.4)",
                borderColor: "rgb(189,10,26)",
                lineTension: 0.1
              }, {
                label: this._getTranslation('diesel'),
                data: data.diesel,
                fill: false,
                backgroundColor: "rgba(245,166,35, 0.4)",
                borderColor: "rgb(245,166,35)",
                lineTension: 0.1
              }
              // {
              //     label: this._getTranslation('erdgascng'),
              //     data: data.naturalGas,
              //     fill: false,
              //     backgroundColor: "rgba(61,173,70, 0.4)",
              //     borderColor: "rgb(61,173,70)",
              //     lineTension: 0.1
              // },
              ];
              Chart.defaults.font.family = 'Kelson, Arial';
              Chart.defaults.font.color = '#000000';
              //Chart.defaults.plugins.legend.position = 'bottom';
              elm = this.renderRoot.querySelector('.rtl-fuelprices-graph');
              Chart.register(LineController, Legend, LineElement, CategoryScale, LinearScale, PointElement);
              chart = new Chart(elm, {
                type: 'line',
                data: {
                  labels: labels,
                  datasets: datasets
                },
                options: {
                  maintainAspectRatio: false,
                  responsive: true,
                  plugins: {
                    legend: {
                      position: 'bottom'
                    }
                  },
                  legend: {
                    labels: {
                      boxWidth: 20
                    }
                  }
                }
              });
              return _context2.abrupt("return", html(_t || (_t = _(_t2 || (_t2 = _``)))));
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function _renderGraph(_x) {
        return _renderGraph2.apply(this, arguments);
      }
      return _renderGraph;
    }()
  }, {
    key: "_renderFuelPrices",
    value: function _renderFuelPrices(prices) {
      return html(_t3 || (_t3 = _`
            <div class="rtl-fuelprices-table-container">
                <div class="rtl-fuelprices-table-wrapper rtl-fuelprices-table-wrapper--margin">
                    <table class="rtl-fuelprices-table">
                        <tr class="rtl-fuelprices-table__row">
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__label">${0}</td>
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__value">${0} &euro;/l</td>
                        </tr>
                        <tr class="rtl-fuelprices-table__row">
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__label">${0}</td>
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__value">${0} &euro;/l</td>
                        </tr>
                        <tr class="rtl-fuelprices-table__row">
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__label">${0}</td>
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__value">${0} &euro;/l</td>
                        </tr>
                        <!--tr class="rtl-fuelprices-table__row">
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__label">${0}</td>
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__value">${0} &euro;/kg</td>
                        </tr-->
                        <tr class="rtl-fuelprices-table__row">
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__label">${0}</td>
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__value">${0} &euro;/l</td>
                        </tr>
                    </table>
                </div>

                <div class="rtl-fuelprices-table-wrapper">
                    <table class="rtl-fuelprices-table">
                        <tr class="rtl-fuelprices-table__row">
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__label">${0}</td>
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__value">${0} &euro;/l</td>
                        </tr>
                        <tr class="rtl-fuelprices-table__row">
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__label">${0}</td>
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__value">${0} &euro;/l</td>
                        </tr>
                        <!--tr class="rtl-fuelprices-table__row">
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__label">${0}</td>
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__value">${0} &euro;/kg</td>
                        </tr>
                        <tr class="rtl-fuelprices-table__row">
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__label">${0}</td>
                            <td class="rtl-fuelprices-table__cell rtl-fuelprices-table__value">${0} &euro;/kg</td>
                        </tr-->
                    </table>
                </div>
            </div>
            <div class="rtl-fuelprices-text">${0}</div>
        `), this._getTranslation('95oct'), prices['95oct'], this._getTranslation('98oct'), prices['98oct'], this._getTranslation('diesel'), prices['diesel'], this._getTranslation('erdgascng'), prices['erdgascng'], this._getTranslation('mazout10ppm'), prices['mazout10ppm'], this._getTranslation('lpg_carburant'), prices['lpg_carburant'], this._getTranslation('propane_vrac'), prices['propane_vrac'], this._getTranslation('propane_bouteille'), prices['propane_bouteille'], this._getTranslation('butane_bouteille'), prices['butane_bouteille'], this._getTranslation('infotext'));
    }
  }, {
    key: "_renderFuelPricesSmall",
    value: function _renderFuelPricesSmall(prices) {
      return html(_t4 || (_t4 = _`
            <div class="rtl-fuelprices-small">
                <div class="rtl-fuelprices-small__item">
                    <b>${0}:</b>  ${0} &euro;/l
                </div>
                <div class="rtl-fuelprices-small__item">
                    <b>${0}:</b> ${0} &euro;/l
                </div>
                <div class="rtl-fuelprices-small__item">
                    <b>${0}:</b> ${0} &euro;/l
                </div>
                <div class="rtl-fuelprices-small__item">
                    <b>${0}:</b> ${0} &euro;/l
                </div>
            </div>
            <div class="rtl-fuelprices-small__text">${0}</div>
        `), this._getTranslation('95oct'), prices['95oct'], this._getTranslation('98oct'), prices['98oct'], this._getTranslation('diesel'), prices['diesel'], this._getTranslation('mazout10ppm'), prices['mazout10ppm'], this._getTranslation('infotext_small'));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.data == undefined) return html(_t5 || (_t5 = _`Loading...`));
      var last = this.data.last;
      var graph = this.data.graph;
      if (this.type == 'graph' || this.type == 'all') this._renderGraph(graph);
      var link = "/mobiliteit/petrolspraisser";
      switch (this.language) {
        case 'fr':
          link = "/mobilite";
          break;
        case 'en':
          link = "/mobility/fuel-prices";
          break;
      }
      return html(_t6 || (_t6 = _`
            <style>${0}</style>

            <div class="rtl-fuelprices rtl-fuelprices--${0} rtl-fuelprices--${0}">
                <div class="rtl-fuelprices__header">
                    ${0}
                    <span class="rtl-fuelprices__date">${0}</span>
                </div>

                <div class="rtl-fuelprices__wrapper">
                    ${0}

                    ${0}

                    ${0}
                </div>
                ${0}
            </div>
        `), css, this.type, this.language, this.type == 'small' || this.type == 'aside' ? html(_t7 || (_t7 = _`<div class="rtl-fuelprices__title">${0}</div>`), this._getTranslation('fuel-prices')) : ``, dayjs(last.date).format('DD.MM.YYYY'), this.type == 'small' || this.type == 'aside' ? this._renderFuelPricesSmall(last) : ``, this.type == 'last' || this.type == 'all' ? this._renderFuelPrices(last) : ``, this.type == 'graph' || this.type == 'all' ? html(_t8 || (_t8 = _`
                        <div class="rtl-fuelprices-graph__container">
                            <canvas class="rtl-fuelprices-graph"></canvas>
                        </div>
                        <div class="rtl-fuelprices__text">${0}</div>
                    `), this._getTranslation('graphtext')) : ``, this.type === "small" ? html(_t9 || (_t9 = _`<a href="${0}" class="block-link__overlay">Fuel prices</a>`), link) : '');
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        language: {
          type: String
        },
        type: {
          type: String
        }
      };
    }
  }]);
  return RTLFuelPrices;
}(LitElement);
export { RTLFuelPrices as default };
window.customElements.define('rtl-fuel-prices', RTLFuelPrices);
function convertGraphData(data) {
  var averagePrices = data.map(function (item) {
    return {
      month: item.month - 1,
      '98oct': item['98oct'],
      '95oct': item['95oct'],
      diesel: item.diesel,
      erdgascng: item.erdgascng
    };
  });
  var dataOct95 = [];
  var dataOct98 = [];
  var dataDiesel = [];
  var dataLabels = [];
  var dataNaturalGas = [];
  var precise = function precise(x, precision) {
    return x.toPrecision(precision);
  };
  var _iterator = _createForOfIteratorHelper(averagePrices),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var item = _step.value;
      dataLabels.push(item.month);
      dataOct95.push(precise(item['95oct'], 3));
      dataOct98.push(precise(item['98oct'], 3));
      dataDiesel.push(precise(item.diesel, 3));
      dataNaturalGas.push(precise(item.erdgascng, 3));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var chartData = {
    labels: dataLabels.reverse(),
    oct95: dataOct95.reverse(),
    oct98: dataOct98.reverse(),
    diesel: dataDiesel.reverse(),
    naturalGas: dataNaturalGas.reverse()
  };
  return chartData;
}